<script setup>
import { ref, defineProps, defineEmits, computed, watchEffect } from 'vue';
import MInput from 'src/components/MInput/index.vue';
import MButton from 'src/components/MButton/index.vue';
import { setCommit } from 'src/utils/common';
import { MAX_NOTE_LENGTH } from 'src/utils/config';

const emit = defineEmits(['input']);
const props = defineProps({
  value: {
    type: Object,
    default: () => ({
      productId: '',
      comment: '',
    }),
  },
});
const comment = ref('');
const inputRef = ref();

function onConfirm() {
  emit('input', { ...props.value, comment: comment.value });
}
watchEffect(() => {
  const { productId, comment: _c } = props.value;
  comment.value = productId ? _c : '';
  inputRef.value?.focus();
});
</script>

<template>
  <q-dialog :value="!!props.value.productId" persistent>
    <div class="comment">
      <div class="comment-head">
        <span bold>
          {{ value.comment ? $t('details.editNotes') : $t('result.notes') }}
        </span>
        <i
          class="iconfont dm-close"
          @click="emit('input', { productId: '', comment: '' })"
        />
      </div>
      <MInput
        ref="inputRef"
        v-model="comment"
        count
        :max="MAX_NOTE_LENGTH"
        :filter="setCommit"
        :placeholder="$t('details.commentHolder')"
      />
      <MButton class="comment-btn" bold primary @click="onConfirm">
        {{ $t('home.save') }}
      </MButton>
    </div>
  </q-dialog>
</template>

<style lang="scss" scoped>
.comment {
  width: 100%;
  background: #fff;
  min-height: 160px;
  padding: 16px;
  border-radius: 8px !important;
  & > div + div {
    margin-top: 8px;
  }
  &-head {
    display: flex;
    justify-content: space-between;
  }
  &-btn {
    width: 100%;
    margin-top: 8px;
  }
}
</style>
